import { render, staticRenderFns } from "./iframeSrc.vue?vue&type=template&id=4b8c069e&scoped=true&"
import script from "./iframeSrc.vue?vue&type=script&lang=js&"
export * from "./iframeSrc.vue?vue&type=script&lang=js&"
import style0 from "./iframeSrc.vue?vue&type=style&index=0&id=4b8c069e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8c069e",
  null
  
)

export default component.exports